import { makeStyles } from "@material-ui/core";

export const stylesMobileAppSendDownloadEmailPopup = makeStyles({
  dialogTitle: {
    height: "auto",
  },
  titleLine: {
    fontSize: "20px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  emailAddressListItem: {
    marginTop: "10px",
  },
  dialogActions: {
    padding: "10px",
  },
});
